var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    strokeWidth: 12,
    stroke: "#000",
    d: "M45 6c21.54 0 39 17.46 39 39S66.54 84 45 84 6 66.54 6 45 23.46 6 45 6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    fill: "#000",
    d: "M24.695 46.935h40.61c.361 0 .72.05 1.067.145 1.953.54 3.059 2.427 2.47 4.216l-.253.721c-.176.477-.37.948-.579 1.41-1.262 2.787-3.11 5.295-5.404 7.395C58.1 64.948 51.876 67.5 45 67.5c-6.875 0-13.1-2.552-17.606-6.678-2.294-2.1-4.142-4.608-5.404-7.395a21.397 21.397 0 01-.832-2.132l-.087-.32a3.111 3.111 0 01-.07-.657c0-1.868 1.654-3.383 3.695-3.383zM52.863 36.3c0-2.651 2.347-4.8 5.242-4.8s5.242 2.149 5.242 4.8-2.347 4.8-5.242 4.8-5.242-2.149-5.242-4.8zM26.652 36.3c0-2.651 2.347-4.8 5.242-4.8s5.242 2.149 5.242 4.8-2.347 4.8-5.242 4.8-5.242-2.149-5.242-4.8z"
  })));
}
export default SvgPlaceholder;